import {get, post} from '../utils/api'
import http from '../utils/api'
import {push} from "connected-react-router";
import {fetchSearchData} from "./searchActions";


export const FETCH_BRAND_BEGIN = 'FETCH_BRAND_BEGIN';
export const FETCH_BRAND_SUCCESS = 'FETCH_BRAND_SUCCESS';
export const UPDATE_BRAND_BEGIN = 'UPDATE_BRAND_BEGIN';
export const UPDATE_BRAND_FAILURE = 'UPDATE_BRAND_FAILURE';
export const UPDATE_BRAND_SORT = 'UPDATE_BRAND_SORT';
export const DELETE_BRAND_BEGIN = 'DELETE_CAMPAIGN_BEGIN';
export const DELETE_BRAND_SUCCESS = 'DELETE_CAMPAIGN_SUCCESS';


export const fetchBrandBegin = () => ({
    type: FETCH_BRAND_BEGIN
});

export const fetchBrandSuccess = (result) => ({
    type: FETCH_BRAND_SUCCESS,
    payload: result
});

export const updateBrandBegin = () => ({
    type: UPDATE_BRAND_BEGIN
});

export const updateBrandFailure = () => ({
    type: UPDATE_BRAND_FAILURE
});

export const updateBrandSort = (column, direction) => ({
    type: UPDATE_BRAND_SORT,
    payload: {
        sort_col: column,
        sort_dir: direction
    }
});
export const deleteBrandBegin = () => ({
    type: DELETE_BRAND_BEGIN
});

export const deleteBrandSuccess = () => ({
    type: DELETE_BRAND_SUCCESS
});

export function fetchBrand(id) {
    return (dispatch, getState) => {
        let state = getState();

        let url = '/brand/' + id;
        let col = state.brand.sort_col;
        let dir = state.brand.sort_dir;

        if (col && dir) {
            url += '?sort_col=' + col + '&sort_dir=' + dir;
        }

        dispatch(fetchBrandBegin());
        return get(url).then((res) => {
            dispatch(fetchBrandSuccess(res));
        });
    };
}

export function updateBrand(id, data) {
    return dispatch => {
        dispatch(updateBrandBegin());
        return post('brand/' + id, data)
            .then((res) => {
                dispatch(fetchBrand(id));
                dispatch(fetchSearchData());
                return res;
            }, function (res) {
                throw res;
            }).catch(err => {
                dispatch(updateBrandFailure(err));
                throw err.response.data;
            });
        };
}
export function deleteBrand(id) {
    return dispatch => {
        return new Promise((resolve, reject) => {
        dispatch(deleteBrandBegin());
        return http.delete('brand/' + id)
            .then(res => {
                dispatch(deleteBrandSuccess());
                dispatch(fetchSearchData());
                resolve()
            });
        })
    };
}
